import { render, staticRenderFns } from "./ModuleTimetable.vue?vue&type=template&id=2a12b7a0"
import script from "./ModuleTimetable.vue?vue&type=script&lang=js"
export * from "./ModuleTimetable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports